import {find} from '../helpers';

const element = find('[data-show-more]');

if (element) {
    import('./index');
}
